import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW5800Model } from '../kymw5800.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWS企画商品一覧表を取得するサービス
 *
 * @export getCwsPlanGoodsCategoryListService
 * @class GetCwsPlanGoodsCategoryListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCwsPlanGoodsCategoryListService extends PlessJsonResponderSub<any> {

  vo = {
    orderCode: '',
    classCode: '',
    categoryCode: '',
    siteDiv: '',
    mediumType: '',
    coopCodeList: []
  };

  // 処理に使用するModel
  private model: KYMW5800Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsPlanGoodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CwsPlanGoodsCategoryList: {
          condition: {
            OrderCode: this.vo.orderCode,
            ClassCode: this.vo.classCode,
            CategoryCode: this.vo.categoryCode,
            SiteDiv: this.vo.siteDiv,
            MediumType: this.vo.mediumType
          },
          combination: this.vo.coopCodeList.map(coopCode => ({
            condition: {
              CoopCode: coopCode
            }
          }))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCwsPlanGoodsCategoryListService
   */
  execute(model: KYMW5800Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCwsPlanGoodsCategoryList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsPlanGoodsCategoryListService
   */
  success(data: any): void {
    // レスポンスのファイルパスをマネージに保存
    this.model.updateFileName(data);
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
